module.exports = {"id":"201862","name":"Marcos Rojo","rating":"81","photo":"./data/images/photos/0/201862.png","club":{"name":"Manchester Utd","logo":"./data/images/clubs/ManchesterUtd.png"},"positions":["DC","DG"],"photoFolderIndex":0}


//////////////////
// WEBPACK FOOTER
// ./src/data/players/MarcosRojo0.json
// module id = 2761
// module chunks = 0